import script from "./FeaturedBooks.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedBooks.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedBooks.vue?vue&type=style&index=0&id=252a1089&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252a1089"]])

export default __exports__